module.exports = __webpack_public_path__ + "static/img/mode-active_disabled@2x.61610ce3.png";